var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigureRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_467_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.471 14.404C14.7668 11.982 12.0567 11.2031 9.0692 11.2031C6.0817 11.2031 3.4463 12.1314 2.66741 14.404C3.37045 15.4417 4.32856 16.2812 5.44967 16.8417C6.57077 17.4023 7.81721 17.6651 9.0692 17.6049C10.3209 17.663 11.5666 17.3993 12.6873 16.8389C13.8081 16.2786 14.7665 15.4402 15.471 14.404Z",
    fill: "#E60D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06919 4.47058C9.91812 4.47058 10.7323 4.80782 11.3326 5.4081C11.9329 6.00838 12.2701 6.82254 12.2701 7.67147C12.2701 8.5204 11.9329 9.33456 11.3326 9.93485C10.7323 10.5351 9.91812 10.8724 9.06919 10.8724C8.22026 10.8724 7.4061 10.5351 6.80582 9.93485C6.20554 9.33456 5.8683 8.5204 5.8683 7.67147C5.8683 6.82254 6.20554 6.00838 6.80582 5.4081C7.4061 4.80782 8.22026 4.47058 9.06919 4.47058Z",
    fill: "#E60D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0692 17.6049C13.7833 17.6049 17.6049 13.7833 17.6049 9.06916C17.6049 4.35502 13.7833 0.533447 9.0692 0.533447C4.35505 0.533447 0.533485 4.35502 0.533485 9.06916C0.533485 13.7833 4.35505 17.6049 9.0692 17.6049Z",
    stroke: "#E60D0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1384,
    height: 18.1384,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureRed);
export default __webpack_public_path__ + "static/media/figure_red.04f9629f222de77d2fe28919be69c011.svg";
export { ForwardRef as ReactComponent };